// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3oLwW","label":"Section_label__3me-i","contentWrap":"Section_contentWrap__12cQG","footer":"Section_footer__1nvB_","footerInner":"Section_footerInner__2925y"};